import { createSelector } from 'reselect';
export const selectAuthState = state => state.auth;
export const getUser = state => state.auth.user || {};
export const getGates = state => state.auth.gates || [];
export const getPortal = state => state.auth.portal;
export const getScopes = state => {
  const user = state.auth.user;
  return user ? user.scopes : [];
};
export const getSidebarRefactorUngated = createSelector(getGates, gates => gates.includes('Notifications:sidebarRefactor'));
export const hasWriteUserScope = createSelector(getScopes, scopes => scopes.includes('users-write'));